<template>
  <div class="w-full">
    <div class="rounded-2xl border border-brand-100 bg-brand-50/50 p-5">
      <div class="mb-6">
        <div class="mb-2 flex items-center justify-between">
          <label class="block text-sm font-bold text-brand-900">Channels</label>
          <div class="text-xs font-semibold">
            <button type="button" class="text-brand-600 hover:underline" @click="setCodes(allCodes)">Select all</button>
            <span class="mx-1 text-gray-300">|</span>
            <button type="button" class="text-brand-600 hover:underline" @click="setCodes([])">Clear</button>
          </div>
        </div>
        <p class="mb-3 text-xs text-gray-500">
          Only customer records from the selected channels are shown to this agency user.
        </p>
        <div class="max-h-56 grid grid-cols-1 gap-2 overflow-y-auto rounded-xl border border-gray-200 bg-white p-3 sm:grid-cols-2">
          <label
            v-for="channel in channelOptions"
            :key="channel.agtCd"
            class="flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <input
              type="checkbox"
              class="rounded border-gray-300 text-brand-600 focus:ring-brand-500"
              :value="channel.agtCd"
              :checked="codes.includes(channel.agtCd)"
              @change="toggleCode(channel.agtCd)"
            />
            <span>
              {{ channel.name }}
              <span class="text-gray-400">({{ channel.agtCd }})</span>
            </span>
          </label>
          <p v-if="channelOptions.length === 0" class="text-sm text-gray-500">No channels available.</p>
        </div>
        <div v-if="channelError" class="mt-1 text-sm text-red-600">{{ channelError }}</div>
      </div>

      <div>
        <div class="mb-2 flex items-center justify-between">
          <label class="block text-sm font-bold text-brand-900">Visible customer columns</label>
          <div class="text-xs font-semibold">
            <button type="button" class="text-brand-600 hover:underline" @click="setColumns(allColumnKeys)">Select all</button>
            <span class="mx-1 text-gray-300">|</span>
            <button type="button" class="text-brand-600 hover:underline" @click="setColumns(defaults)">Defaults</button>
            <span class="mx-1 text-gray-300">|</span>
            <button type="button" class="text-brand-600 hover:underline" @click="setColumns([])">Clear</button>
          </div>
        </div>
        <p class="mb-3 text-xs text-gray-500">
          Unticked columns are removed from the table, search, and Excel export.
        </p>
        <div class="max-h-72 grid grid-cols-1 gap-2 overflow-y-auto rounded-xl border border-gray-200 bg-white p-3 sm:grid-cols-3">
          <label
            v-for="column in columnOptions"
            :key="column.key"
            class="flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <input
              type="checkbox"
              class="rounded border-gray-300 text-brand-600 focus:ring-brand-500"
              :value="column.key"
              :checked="columns.includes(column.key)"
              @change="toggleColumn(column.key)"
            />
            <span>{{ column.label }}</span>
          </label>
        </div>
        <div v-if="columnError" class="mt-1 text-sm text-red-600">{{ columnError }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    codes: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    channelOptions: { type: Array, default: () => [] },
    columnOptions: { type: Array, default: () => [] },
    defaults: { type: Array, default: () => [] },
    channelError: { type: String, default: null },
    columnError: { type: String, default: null },
  },
  emits: ['update:codes', 'update:columns'],
  computed: {
    allCodes() {
      return this.channelOptions.map((channel) => channel.agtCd)
    },
    allColumnKeys() {
      return this.columnOptions.map((column) => column.key)
    },
  },
  methods: {
    setCodes(codes) {
      this.$emit('update:codes', [...codes])
    },
    setColumns(columns) {
      this.$emit('update:columns', [...columns])
    },
    toggleCode(code) {
      this.setCodes(this.codes.includes(code) ? this.codes.filter((c) => c !== code) : [...this.codes, code])
    },
    toggleColumn(key) {
      this.setColumns(this.columns.includes(key) ? this.columns.filter((c) => c !== key) : [...this.columns, key])
    },
  },
}
</script>
